import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { usePage } from '@wbk/contentful/api';
import { useParams } from 'react-router-dom';
import FullpageAnimatedLogo from '@/components/ui/Loading/FullpageAnimatedLogo';
import Seo from '@/components/headers/seo';
import Error404 from '@/components/error/404';
import HomepageSections from '@/components/web-sections/HomepageSections';

const Home = () => {
  const { lang } = useParams<{ lang: Language }>();
  const {
    data: home,
    isLoading,
    error,
  } = usePage({ lang, limit: 1, where: { slug: 'riyadh-season' } });
  const [introFinished, setIntroFinished] = useState(false);
  const [hideVideo, setHideVideo] = useState(false);
  const footer = document.getElementById('footer');

  useEffect(() => {
    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHideVideo(entry.isIntersecting);
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(footer);

    return () => {
      observer.disconnect();
    };
  }, [footer]);

  if (isLoading) {
    return <FullpageAnimatedLogo />;
  }

  if (!home || error) {
    return <Error404 />;
  }

  return (
    <>
      <Seo
        title={home.seo?.title || home.title}
        description={home.seo?.description}
        image={home.seo?.image?.url}
      />

      <div className='relative h-full w-full'>
        <video
          className={twMerge(
            'no-controls background-video pointer-events-none fixed left-1/2 top-0 h-full w-full -translate-x-1/2 object-cover opacity-30',
            hideVideo && 'opacity-0'
          )}
          src={home.background?.url}
          autoPlay
          loop
          muted
          playsInline
          style={{ zIndex: -1 }}
        />

        <div className='col-span-12 space-y-24'>
          {home?.sectionsCollection.items.map((section, idx) =>
            section.__typename === 'WebSection' ? (
              <HomepageSections
                key={section.__typename + idx}
                section={section}
                introFinished={introFinished}
                setIntroFinished={setIntroFinished}
              />
            ) : null
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
